var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'Login' && _vm.$store.state.isLoading)?_c('Loader'):_vm._e(),(_vm.$route.name !== 'Login')?_c('Nav'):_vm._e(),_c('router-view'),(_vm.$store.state.organisation.subdomain == 'thebe-extra' && _vm.$route.name !== 'Login')?_c('Notice'):_vm._e(),(_vm.$route.name !== 'Login')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }